import React, { useState } from 'react'
import styles from './styles.module.css'
import ProgressiveImage from '../../ProgressiveImage'
import Text from '../../../Text'
import { PALETTE } from '../../../../styles/constants'

function Gallery({ name, images, show }) {
  const [selectedId, setSelectedId] = useState(0)

  return (
    <div className={styles.wrapper} style={{ display: show ? 'flex' : 'none' }}>
      <div className={styles.thumbnailsWrapper} style={{ display: images.length > 1 ? 'flex' : 'none' }}>
        {
          images
            .map((image, index) =>
              <div
                className={index === selectedId ? `${styles.thumbnail} ${styles.thumbnailSelected}` : styles.thumbnail}
                key={`${name}-${index}-thumbnail`}
                onClick={() => setSelectedId(index)}
              >
                {/* `image` is a ResolvedImage descriptor (task #72): bucket
                    variants + CSS blur, base64/appspot placeholder already
                    dropped server-side. Carry the option name as alt. */}
                <ProgressiveImage
                  image={image}
                  alt={(image && image.alt) || `${name}-${index}-thumbnail`}
                />
              </div>
            )
        }
      </div>
      <div className={styles.imagesWrapper}>
        {
          images
            .map((image, index) =>
              <div
                className={styles.imageWrapper}
                key={`${name}-${index}-image`}
                style={{ opacity: selectedId === index ? '1' : '0' }}
              >
                {/* Eager/priority for the first view of the visible rig; the
                    rest stay lazy. */}
                <ProgressiveImage
                    image={image}
                    alt={(image && image.alt) || `${name}-${index}`}
                    priority={show && index === 0}
                />
              </div>
          )
        }
      </div>
      <div className={styles.disclaimerTextWrapper}>
        <Text type="tiny" color={PALETTE.gray80}>Images may differ from actual product. Customer choices may alter appearance of product.</Text>
      </div>
    </div>
  )
}

export default Gallery
